import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronLeft, Building2 } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
export function BusinessPage() {
  const navigate = useNavigate();
  const {
    updateBusiness
  } = useAuth();
  const handleChoice = (hasBusiness: boolean) => {
    updateBusiness({
      hasBusiness
    });
    if (hasBusiness) {
      navigate('/onboarding/business-details');
    } else {
      navigate('/onboarding/summary');
    }
  };
  const handleBack = () => {
    navigate('/onboarding/preferences');
  };
  return <div className="min-h-screen bg-aliceBlue flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-1264">
      <div className="sm:mx-auto sm:w-full sm:max-w-xl" data-id="element-1265">
        <div className="mb-8" data-id="element-1266">
          <div className="flex justify-between items-center mb-2" data-id="element-1267">
            <span className="text-sm font-semibold text-primary" data-id="element-1268">
              Business Profile
            </span>
            <span className="text-sm font-medium text-secondary" data-id="element-1269">Step 3</span>
          </div>
          <div className="w-full bg-borderColor rounded-full h-2" data-id="element-1270">
            <div className="bg-violetBlue h-2 rounded-full transition-all duration-300" style={{
            width: '75%'
          }} data-id="element-1271"></div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white py-12 px-6 shadow-sm sm:rounded-xl sm:px-12 border border-borderColor text-center" data-id="element-1272">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-aliceBlue mb-6" data-id="element-1273">
            <Building2 className="h-8 w-8 text-violetBlue" data-id="element-1274" />
          </div>
          <h2 className="text-3xl font-bold text-primary mb-4" data-id="element-1275">
            Do you own, run, or help manage a business?
          </h2>
          <p className="text-lg text-secondary mb-8" data-id="element-1276">
            We include a comprehensive business legal health check for business
            owners.
          </p>

          <div className="flex flex-col gap-4 max-w-sm mx-auto" data-id="element-1277">
            <button onClick={() => handleChoice(true)} className="w-full py-4 px-4 border border-transparent rounded-lg shadow-sm text-lg font-semibold text-white bg-violetBlue hover:opacity-90 transition-opacity" data-id="element-1278">
              Yes
            </button>
            <button onClick={() => handleChoice(false)} className="w-full py-4 px-4 border border-borderColor rounded-lg text-lg font-semibold text-primary bg-white hover:bg-aliceBlue transition-colors" data-id="element-1279">
              No
            </button>
            <button onClick={() => handleChoice(false)} className="w-full py-3 px-4 border border-borderColor rounded-lg text-base font-medium text-secondary bg-white hover:bg-aliceBlue transition-colors" data-id="element-1280">
              Not right now — I can add this later
            </button>
          </div>

          <div className="mt-8 flex justify-center" data-id="element-1281">
            <button onClick={handleBack} className="flex items-center text-sm font-semibold text-secondary hover:text-primary transition-colors" data-id="element-1282">
              <ChevronLeft className="w-4 h-4 mr-1" data-id="element-1283" /> Back to Assessment Intent
            </button>
          </div>
        </motion.div>
      </div>
    </div>;
}